import { render } from "./beneficiary_Expertise.vue?vue&type=template&id=c715fe10&scoped=true"
import script from "./beneficiary_Expertise.vue?vue&type=script&lang=js"
export * from "./beneficiary_Expertise.vue?vue&type=script&lang=js"

import "./beneficiary_Expertise.vue?vue&type=style&index=0&id=c715fe10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c715fe10"]])

export default __exports__